import { isBrowser } from '../constants';
import { publicApi } from './index';

export const editFileAPI = async (
  uuid: string,
  name: string,
  description: string,
  recaptchaToken: string
) => {
  const body = new FormData();
  if (name) {
    body.append('name', name);
  }
  if (description) {
    body.append('description', description);
  }
  return publicApi.post(
    `/file/${uuid}/edit`,
    body,
    isBrowser && localStorage.getItem('token')
      ? {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            RecaptchaToken: recaptchaToken,
          },
        }
      : {}
  );
};
